export enum EContractType {
  STANDARD = "STANDARD",
  ALPA = "ALPA",
  RMA = "RMA",
}

export enum EContractTypeLabel {
  STANDARD = "Standard Private Sale",
  ALPA = "ALPA Private Sale",
  RMA = "RMA Private Sale",
}

export enum EContractParty {
  BUYER = "buyer",
  VENDOR = "vendor",
}
